import { Box, Toolbar } from "@mui/material";

function LmsMain({ children }) {
  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Toolbar />
      <Box
        sx={(theme) => ({
          px: { xs: "15px", sm: "15px", md: "45px" },
          py: { xs: "10px", sm: "45px" },
          background: theme.palette.mode === "dark" ? "#121212" : "#F6F5F4",
          flex: 1,
          overflowY: "auto",
        })}
      >
        {children}
      </Box>
    </Box>
  );
}

export default LmsMain;
